import { render, staticRenderFns } from "./FormThuxHorizontalFileThux.vue?vue&type=template&id=87e785b0&"
import script from "./FormThuxHorizontalFileThux.vue?vue&type=script&lang=js&"
export * from "./FormThuxHorizontalFileThux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports